<template>
  <template v-if="isLogged">
    <menu class="sidebar">
      <nav>
        <ul>
          <li class="logo tooltip" title="uForm Panel">
            <router-link to="/">
              <img :src="logoHeader" alt="uForm Panel" class="dark" />
              <img :src="logoHeaderLight" alt="uForm Panel" class="light" />
            </router-link>
          </li>
          <li
            v-for="(menu, index) in menus"
            :key="index"
            class="menu-item"
            :class="{ actived: activeMenus[index] }"
          >
            <span class="title" @click="toggleMenu(index)">
              <i :class="menu.icon"></i> {{ menu.title }}
            </span>
            <ul class="submenu" v-if="activeMenus[index]">
              <li
                v-for="(submenu, subIndex) in menu.submenus"
                :key="subIndex"
                class="submenu-item"
              >
                <router-link :to="submenu.link">
                  <i :class="submenu.icon"></i> {{ submenu.title }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </menu>
  </template>
</template>

<script>
export default {
  props: {
    isLogged: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      logoHeader: process.env.BASE_URL + 'images/header/logo_header.png',
      logoHeaderLight: process.env.BASE_URL + 'images/header/logo_header_light.png',
      activeMenus: {}, // Objeto para rastrear quais menus estão abertos
      menus: [
        {
          title: "Educacional",
          icon: "bi bi-mortarboard-fill",
          submenus: [
            { title: "Alunos", link: "/students/", icon: "bi bi-people-fill" },
            { title: "Cursos", link: "/courses/", icon: "bi bi-book" },
          ],
        },
        {
          title: "Videos",
          icon: "bi bi-camera-video",
          submenus: [
            { title: "Lista de Vídeos", link: "/videos-list/", icon: "bi bi-film" },
            { title: "Upload Vídeos", link: "/videos-upload/", icon: "bi bi-cloud-arrow-up" },
            { title: "Edição de Vídeo", link: "/videos-edit/", icon: "bi bi-person-video2" },
          ],
        },
        {
          title: "Financeiro",
          icon: "bi bi-cash-coin",
          submenus: [
            {
              title: "Pagamentos",
              link: "/payments/",
              icon: "bi bi-credit-card-2-front-fill",
            },
            {
              title: "Recebimentos",
              link: "/payments2/",
              icon: "bi bi-currency-dollar",
            },
            {
              title: "Transferências",
              link: "/payments3/",
              icon: "bi bi-currency-exchange",
            },
          ],
        },
        {
          title: "Ferramentas Administrativas",
          icon: "bi bi-tools",
          submenus: [
            { title: "Usuários", link: "/users/", icon: "bi bi-person-fill" },
            { title: "Permissões", link: "/permissions/", icon: "bi bi-shield-lock" },
            { title: "Configurações", link: "/settings/", icon: "bi bi-gear" },
          ],
        },
      ],
    };
  },
  methods: {
    toggleMenu(index) {
      // Alterna o estado do menu individual
      this.activeMenus[index] = !this.activeMenus[index];
    },
    updateActiveLink() {
      let currentPath = this.$route.path.split('?')[0]; // Remove a query string
      if (!currentPath.endsWith('/')) {
        currentPath += '/'; // Adiciona uma barra no final se não tiver
      }
      if (currentPath.endsWith("login/")) {
        this.activeMenus = {}; // Reseta os submenus abertos
        return;
      }
      this.menus.forEach((menu, menuIndex) => {
        menu.submenus.forEach((submenu, subIndex) => {
          const isActive = currentPath.startsWith(submenu.link);
          if (isActive) {
            this.activeMenus[menuIndex] = true;
            this.$nextTick(() => {
              const subAllMenus = this.$el.querySelectorAll(`a`);
              if(subAllMenus){
                subAllMenus.forEach((menu) => {
                  menu.classList.remove("actived");
                });
              }
              const submenuElement = this.$el.querySelector(`a[href='${submenu.link}']`);
              if (submenuElement) {
                // console.log(submenu.link);
                submenuElement.classList.add("actived");
              }
            });
          }
        });
      });
    }
  },
  mounted() {
    // Chama o método ao montar o componente
    this.updateActiveLink();
  },
  watch: {
    // Observa mudanças na rota
    $route() {
      this.updateActiveLink();
    },
  }
};
</script>

<style src="@/assets/css/menu-style.css"></style>